import {
  AttachmentControllerDeleteAttachmentParams,
  AttachmentControllerGetAttachmentParams,
  AttachmentControllerGetAttachmentsParams,
  InitAttachmentUploadDto,
  RequestParams
} from '@api/Api';
import { apiClient } from '@api/client';

export const initAttachmentUpload = (
  data: InitAttachmentUploadDto,
  params: RequestParams = {}
) =>
  apiClient.attachment.attachmentControllerInitAttachmentUpload(data, params);

export const attachmentGetAttachment = (
  data: AttachmentControllerGetAttachmentParams,
  params: RequestParams = {}
) => apiClient.attachment.attachmentControllerGetAttachment(data, params);

export const attachmentDeleteAttachment = (
  data: AttachmentControllerDeleteAttachmentParams,
  params: RequestParams = {}
) => apiClient.attachment.attachmentControllerDeleteAttachment(data, params);

export const attachmentGetAttachments = (
  data: AttachmentControllerGetAttachmentsParams,
  params: RequestParams = {}
) => apiClient.attachment.attachmentControllerGetAttachments(data, params);
